export default __webpack_public_path__ + "static/media/logo-jira.c19fd4e4.svg";